<template>
  <portlet>
    <div class="row mb-5">
      <div class="col-12 col-md-6">
        <table-wrapper>
          <table-row>
            <table-heading
              :cols="3"
              class="text-center"
            >
              攤位編號
            </table-heading>
            <table-heading
              :cols="9"
              class="text-center"
            >
              廠商名稱
            </table-heading>
          </table-row>
          <table-row
            v-for="n in firstHalf"
            :key="n"
          >
            <table-data
              :cols="3"
              class="text-center"
            >
              {{ n }}
            </table-data>
            <table-data
              :cols="9"
              class="text-center"
            >
              <template v-if="nthBoothGetter(n)">
                <template v-if="showBooked && bookedBooths.includes(n)">
                  <span class="text-primary font-weight-bold">{{ nthBoothGetter(n) }}（已選取）</span>
                </template>
                <template v-else>
                  <span class="font-weight-bold">{{ nthBoothGetter(n) }}</span>
                </template>
              </template>

              <template v-else>
                <template v-if="readOnly || limitReached">
                  <span class="text-muted">目前尚有名額</span>
                </template>
                <button-wrapper
                  v-else
                  :disabled="!addingAvailable"
                  class="getBoothReservation"
                  fill
                  @click="bookABooth(n)"
                >
                  目前尚有名額
                </button-wrapper>
              </template>
            </table-data>
          </table-row>
        </table-wrapper>
      </div>
      <div class="col-12 col-md-6">
        <table-wrapper>
          <table-row class="d-none d-md-flex">
            <table-heading
              :cols="3"
              class="text-center"
            >
              攤位編號
            </table-heading>
            <table-heading
              :cols="9"
              class="text-center"
            >
              廠商名稱
            </table-heading>
          </table-row>
          <table-row
            v-for="n in lastHalf"
            :key="n"
          >
            <table-data
              :cols="3"
              class="text-center"
            >
              {{ n }}
            </table-data>
            <table-data
              :cols="9"
              class="text-center"
            >
              <template v-if="nthBoothGetter(n)">
                <template v-if="showBooked && bookedBooths.includes(n)">
                  <span class="text-primary font-weight-bold">{{ nthBoothGetter(n) }}（已選取）</span>
                </template>
                <template v-else>
                  <span class="font-weight-bold">{{ nthBoothGetter(n) }}</span>
                </template>
              </template>

              <template v-else>
                <template v-if="readOnly || limitReached">
                  <span class="text-muted">目前尚有名額</span>
                </template>
                <button-wrapper
                  v-else
                  :disabled="!addingAvailable"
                  class="getBoothReservation"
                  fill
                  @click="bookABooth(n)"
                >
                  目前尚有名額
                </button-wrapper>
              </template>
            </table-data>
          </table-row>
        </table-wrapper>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <bootstrap-pagination
          v-if="pageGetter.page_total > 1"
          :total-page-number="pageGetter.page_total"
          :display-page-number="8"
          @number:updated="updateBoothPage"
        />
      </div>
    </div>
  </portlet>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { mToN } from '~utils/filters'
import Portlet from '~components/common/Portlet'
import BootstrapPagination from '~bootstrap/Pagination'
import TableWrapper from '~components/common/tables'
import TableRow from '~components/common/tables/Row'
import TableHeading from '~components/common/tables/Heading'
import TableData from '~components/common/tables/Data'
import ButtonWrapper from '~components/common/buttons'
export default {
  name: 'BoothListTable',
  components: {
    Portlet,
    BootstrapPagination,
    TableWrapper,
    TableRow,
    TableHeading,
    TableData,
    ButtonWrapper
  },
  props: {
    limitReached: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    showBooked: {
      type: Boolean,
      default: false
    },
    bookedBooths: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentPageNumber: 1,
      addingAvailable: !this.readOnly
    }
  },
  computed: {
    ...mapGetters('pages/campus-recruiting', [
      'currentExpoDetailsGetter',
      'nthBoothGetter',
      'pageGetter'
    ]),
    currentPageBoothNumbers () {
      if (Object.keys(this.pageGetter).length) {
        return mToN(this.pageGetter.item_from, this.pageGetter.item_to)
      }
      return []
    },
    firstHalf () {
      return this.currentPageBoothNumbers.slice(0, Math.ceil(this.pageGetter.item_quantity / 2))
    },
    lastHalf () {
      return this.currentPageBoothNumbers.slice(Math.ceil(this.pageGetter.item_quantity / 2), this.pageGetter.item_quantity)
    },
    allBoothItems () {
      return [this.lastHalf, this.lastHalf]
    }
  },
  methods: {
    updateBoothPage (page) {
      this.$emit('update:page', page)
    },
    bookABooth (n) {
      this.$emit('add:booth', n)
    }
  }
}
</script>
